import { PayloadAction, createSelector, createSlice } from '@reduxjs/toolkit'
import { createBaseSelector, registerSlice } from '@shared/lib/redux'

import { defaultTheme } from '../../lib'

type ThemeState = {
  isDarkTheme: boolean
}

const initialState: ThemeState = {
  isDarkTheme: defaultTheme
}

const themeSlice = createSlice({
  name: 'themeSlice',
  initialState,
  reducers: {
    toggleDarkTheme: (state, action: PayloadAction<boolean>) => {
      state.isDarkTheme = action.payload
    }
  }
})

const themeBaseSelector = createBaseSelector(themeSlice)
const selectIsDarkTheme = createSelector(
  themeBaseSelector,
  (s) => s.isDarkTheme
)

registerSlice([themeSlice])

export const themeStore = {
  actions: { ...themeSlice.actions },
  selectors: {
    selectIsDarkTheme
  }
}

// export const { toggleDarkTheme } = themeSlice.actions
// export const reducer = themeSlice.reducer
// export const isDarkTheme = (state: RootState) => state.themeReducer.isDarkTheme
